/* src/app/module/user-dashboard/period-selector/custom-date-range-picker/custom-date-range-picker.component.scss */
.calendar-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.calendar-modal {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  width: 320px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}
.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.calendar-header h3 {
  margin: 0;
}
.calendar-header button {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}
.calendar-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 20px 0;
}
.calendar-body label {
  font-weight: 600;
}
.calendar-body input[type=date] {
  padding: 6px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
}
.calendar-footer {
  display: flex;
  justify-content: flex-end;
}
.calendar-footer button {
  background-color: #ffa500;
  border: none;
  padding: 8px 16px;
  color: white;
  font-weight: bold;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}
.calendar-footer button:hover {
  background-color: #e69500;
}
.calendar-footer button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
/*# sourceMappingURL=custom-date-range-picker.component-IXTK76YT.css.map */
